import { MetabaseCard } from '@shared/components/metabase';

export class ResaleReportModel extends MetabaseCard {}
